// "My Files" sheet content helpers, shared by FiuGrid (snapshot) and SheetView (chunked autosave).

// Rows per stored chunk; must match CHUNK_ROWS in server/utils/grid_utils.js
export const CHUNK_ROWS = 250;

// Cells as strings, without trailing empty cells / rows (the grid pads with empty rows)
export function trimSheetRows(data) {
    const rows = (Array.isArray(data) ? data : []).map((row) => {
        const cells = (Array.isArray(row) ? row : []).map(value => (value === null || value === undefined) ? '' : value.toString());
        while (cells.length && cells[cells.length - 1] === '') cells.pop();
        return cells;
    });
    while (rows.length && rows[rows.length - 1].length === 0) rows.pop();
    return rows;
}

// Trimmed rows -> one JSON string per chunk, to tell which chunks changed since the last save
export function chunkKeys(rows) {
    const keys = [];
    for (let start = 0; start < rows.length; start += CHUNK_ROWS) {
        keys.push(JSON.stringify(rows.slice(start, start + CHUNK_ROWS)));
    }
    return keys;
}
